document.addEventListener('DOMContentLoaded', function() {
    var productGrids = document.querySelectorAll('.grid.product-grid');
    var viewState = 'One'; // Default to "One"

    // Toggle buttons for switching views
    var viewByOneButton = document.getElementById("global-view-one");
    var viewByTwoButton = document.getElementById("global-view-two");

    if (viewByOneButton && viewByTwoButton) {
        viewByOneButton.addEventListener("click", function () {
            viewState = 'One';
            viewByOneButton.classList.add("active");
            viewByTwoButton.classList.remove("active");
            toggleImages('one');
        });

        viewByTwoButton.addEventListener("click", function () {
            viewState = 'Two';
            viewByTwoButton.classList.add("active");
            viewByOneButton.classList.remove("active");
            toggleImages('two');
        });
    }

    // Function to toggle images based on view state
 //   function toggleImages(view) {
  //      document.querySelectorAll('.view-image-one').forEach(img => img.style.display = view === 'one' ? 'block' : 'none');
 //       document.querySelectorAll('.view-image-two').forEach(img => img.style.display = view === 'two' ? 'block' : 'none');
//    }

    // Function to set the image based on variant data and view state
    function setImageForView(card, variantData, viewClass) {
        var productImageElement = card.querySelector(`.card__media .${viewClass}`);
        if (productImageElement) {
            var lazyLoadAllVariants = card.getAttribute('data-lazy-load-all-variants') === 'true';
            if (lazyLoadAllVariants) {
                var preloadedImage = card.querySelector(`img[data-variant-id="${variantData.variantId}"]`);
                if (preloadedImage) {
                    productImageElement.src = preloadedImage.src;
                    productImageElement.srcset = preloadedImage.srcset;
                } else {
                    console.log('Matching preloaded image not found for variant:', variantData.variantId);
                }
            } else {
                // Update src and srcset for responsive images
                var dynamicSrcset = [
                    variantData.imageUrl + '?width=165 165w',
                    variantData.imageUrl + '?width=360 360w',
                    variantData.imageUrl + '?width=533 533w',
                    variantData.imageUrl + '?width=720 720w',
                    variantData.imageUrl + '?width=940 940w',
                    variantData.imageUrl + '?width=1066 1066w'
                ].join(', ');
                productImageElement.src = variantData.imageUrl;
                productImageElement.srcset = dynamicSrcset;
            }
            productImageElement.style.display = 'block';
        } else {
            console.log(`No product image element found for view: ${viewClass}`);
        }
    }

    productGrids.forEach(function(productGrid) {
        var sectionId = productGrid.getAttribute('data-section-id');
        var variantDataMap = window['variantDataMap' + sectionId.replace(/-/g, '_')];
        
        productGrid.addEventListener('change', function(e) {
            if (e.target.matches('input[type="radio"][data-section-id="' + sectionId + '"]')) {
                var card = e.target.closest(`.card-product-custom-div[data-section-id="${sectionId}"]`);
                var variantId = e.target.getAttribute('data-variant-id');
                var variantData = variantDataMap[variantId];
                
                if (!variantData) {
                    console.log('No data found for variant:', variantId);
                    return;
                }

                // Update image based on current view state
                if (viewState === 'One') {
                    setImageForView(card, variantData, 'view-image-one');
                } else {
                    setImageForView(card, variantData, 'view-image-two');
                }

                // Update the product URL
                var productLinks = card.querySelectorAll('a[id^="CardLink-"], a[id^="StandardCardNoMediaLink-"]');
                productLinks.forEach(function(link) {
                    link.href = variantData.productUrl;
                });
            } else {
                console.log('Change detected, but not on a swatch input.');
            }
        });
    });
});
